import Model from './Model';

export default class Organisation extends Model {
    code;
    description;
    email;
    employees;
    fte;
    hrm_email;
    location_description;
    location_logo;
    logo;
    movie;
    name;
    notes;
    phone_number;
    seo_url;
    state;
    token;
    website;

    static apiPath() {
        return 'organisations';
    }
}



// WEBPACK FOOTER //
// ./src/models/Organisation.js